// version.json
var version_default = [
  {
    version: "0.7.20",
    date: "2026-10-25",
    changes: [
      "- Domains: the home page and the price page lead with the renewal price; the price page lists registration, renewal and transfer per TLD and compares 5 years with hosttech, Hostpoint, NetZone and cyon",
      "- Sign-in: after a Google or GitHub sign-in the clicked button shows progress until you are redirected",
      "- Domain transfer: the single/batch tabs are centred over the form"
    ]
  },
  {
    version: "0.7.20-dev.1",
    date: "2026-10-25",
    changes: [
      "- Domains: the home page and the price page lead with the renewal price; the price page lists registration, renewal and transfer per TLD and compares 5 years with hosttech, Hostpoint, NetZone and cyon",
      "- Sign-in: after a Google or GitHub sign-in the clicked button shows progress until you are redirected",
      "- Domain transfer: the single/batch tabs are centred over the form"
    ]
  },
  {
    version: "0.7.19",
    date: "2026-10-24",
    changes: [
      "- Website hosting: build your website with the ChatGPT or Claude you already have: paste one line, answer its questions, upload the one file it gives you (ywt.ch/ai, docs.ywt.ch/ai)",
      '- Website hosting: the empty Edit tab offers "Build it with your AI assistant"; the upload dialog ("Upload your website") accepts a single index.html as well as a zip',
      "- Website hosting: saving a large page (inline styles, embedded images) no longer fails with a server error; the limit is now 6 MB and is reported as such"
    ]
  },
  {
    version: "0.7.19-dev.3",
    date: "2026-10-24",
    changes: ["- Internal: the /mcp connector test endpoint is removed again (the connector work is parked; the one-line prompt path stays)"]
  },
  {
    version: "0.7.19-dev.2",
    date: "2026-10-24",
    changes: ["- Internal: an unauthenticated connector endpoint at /mcp with one test tool, dev only (refused in production), to check which AI assistants can run tools that change data"]
  },
  {
    version: "0.7.19-dev.1",
    date: "2026-10-24",
    changes: [
      "- Website hosting: build your website with the ChatGPT or Claude you already have: paste one line, answer its questions, upload the one file it gives you (ywt.ch/ai, docs.ywt.ch/ai)",
      '- Website hosting: the empty Edit tab offers "Build it with your AI assistant"; the upload dialog ("Upload your website") accepts a single index.html as well as a zip',
      "- Website hosting: saving a large page (inline styles, embedded images) no longer fails with a server error; the limit is now 6 MB and is reported as such"
    ]
  },
  {
    version: "0.7.18",
    date: "2026-10-23",
    changes: [
      "- Domain registration: an order whose domain was already registered at SWITCH by an earlier, interrupted attempt is now completed on retry (SWITCH sends no creation date; it is taken as one year before expiry)"
    ]
  },
  {
    version: "0.7.18-dev.1",
    date: "2026-10-23",
    changes: [
      "- Domain registration: an order whose domain was already registered at SWITCH by an earlier, interrupted attempt is now completed on retry (SWITCH sends no creation date; it is taken as one year before expiry)"
    ]
  },
  {
    version: "0.7.17",
    date: "2026-10-23",
    changes: [
      "- Sign-up: a new email account is signed in straight away and continues where it was going (e.g. back to checkout) instead of being sent to the sign-in form",
      "- Sign-in/sign-up: a failed sign-in offers to create an account with the typed email, an existing address offers to sign in, too many attempts and closed popups get their own messages",
      "- Forms: password managers and autofill work, show/hide password, live password checklist, translated errors; signing in no longer applies the new-password rules",
      "- Email confirmation is optional with a reminder and resend in the account; verification and password-reset links open our own ywt.ch/auth/action page (confirm, or choose a new password and sign in)",
      "- Emails: honest verification copy and a plain-link fallback in both auth emails"
    ]
  },
  {
    version: "0.7.16",
    date: "2026-10-23",
    changes: ["- Domain registry service: oversized or malformed requests and registry outages are answered with a clean error instead of being reported as crashes"]
  },
  {
    version: "0.7.16-dev.2",
    date: "2026-10-23",
    changes: [
      "- Sign-up: a new email account is signed in straight away and continues where it was going (e.g. back to checkout) instead of being sent to the sign-in form",
      "- Sign-in/sign-up: a failed sign-in offers to create an account with the typed email, an existing address offers to sign in, too many attempts and closed popups get their own messages",
      "- Forms: password managers and autofill work, show/hide password, live password checklist, translated errors; signing in no longer applies the new-password rules",
      "- Email confirmation is optional with a reminder and resend in the account; verification and password-reset links open our own ywt.ch/auth/action page (confirm, or choose a new password and sign in)",
      "- Emails: honest verification copy and a plain-link fallback in both auth emails"
    ]
  },
  {
    version: "0.7.16-dev.1",
    date: "2026-10-23",
    changes: ["- Domain registry service: oversized or malformed requests and registry outages are answered with a clean error instead of being reported as crashes"]
  },
  {
    version: "0.7.15",
    date: "2026-10-09",
    changes: [
      "- Domain transfers: a transfer can no longer be ordered for a domain another YWT customer holds; the order is refused and refunded before anything changes",
      '- DNS: "Certificate automation" on the domain page creates keys that let certbot, acme.sh and lego answer ACME DNS-01 challenges (RFC 2136, TXT records at _acme-challenge only)'
    ]
  },
  {
    version: "0.7.15-dev.1",
    date: "2026-10-09",
    changes: [
      "- Domain transfers: a transfer can no longer be ordered for a domain another YWT customer holds; the order is refused and refunded before anything changes",
      '- DNS: "Certificate automation" on the domain page creates keys that let certbot, acme.sh and lego answer ACME DNS-01 challenges (RFC 2136, TXT records at _acme-challenge only)'
    ]
  },
  {
    version: "0.7.14",
    date: "2026-10-07",
    changes: ['- DNS manager: NS records on subdomains (delegations) are listed and can be edited or deleted; the "Auto" TTL, which was served as 1 second, is replaced by a 1 hour default']
  },
  {
    version: "0.7.14-dev.1",
    date: "2026-10-07",
    changes: ['- DNS manager: NS records on subdomains (delegations) are listed and can be edited or deleted; the "Auto" TTL, which was served as 1 second, is replaced by a 1 hour default']
  },
  {
    version: "0.7.13",
    date: "2026-10-05",
    changes: ["- Domains on YWT DNS: pointing a domain at a website or forward replaces its old address records instead of adding ours next to them"]
  },
  {
    version: "0.7.13-dev.1",
    date: "2026-10-05",
    changes: ["- Domains on YWT DNS: pointing a domain at a website or forward replaces its old address records instead of adding ours next to them"]
  },
  {
    version: "0.7.12",
    date: "2026-10-05",
    changes: [
      "- URL forwarding: the HTTPS badge shows the real state (waiting for DNS, issuing, active), and a new domain's certificate is requested right away",
      "- Security: custom domains get HSTS, only our edge can request certificates (at most 5 new wildcard subdomains per domain and day), and draft links are signed with their own key (links shared before this release need to be shared again)"
    ]
  },
  {
    version: "0.7.12-dev.1",
    date: "2026-10-05",
    changes: [
      "- URL forwarding: the HTTPS badge shows the real state (waiting for DNS, issuing, active), and a new domain's certificate is requested right away",
      "- Security: custom domains get HSTS, only our edge can request certificates (at most 5 new wildcard subdomains per domain and day), and draft links are signed with their own key"
    ]
  },
  {
    version: "0.7.11",
    date: "2026-10-04",
    changes: [
      "- Website hosting: one Settings page per site (name, icon, path redirects under Advanced, delete); the Domains tab shows only domains",
      "- Website hosting: the site Overview is one panel; History, Visitors, Performance and Settings are rows with their values, next to a preview as tall as the panel"
    ]
  },
  {
    version: "0.7.11-dev.3",
    date: "2026-10-04",
    changes: ["- Website hosting: the Overview's preview card is as tall as the site panel"]
  },
  {
    version: "0.7.11-dev.2",
    date: "2026-10-04",
    changes: ["- Website hosting: the site Overview is one panel; History, Visitors, Performance and Settings are rows with their values"]
  },
  {
    version: "0.7.11-dev.1",
    date: "2026-10-04",
    changes: ["- Website hosting: one Settings page per site (name, icon, path redirects under Advanced, delete); the Domains tab shows only domains"]
  },
  {
    version: "0.7.10",
    date: "2026-10-04",
    changes: [
      "- Domains: customers restore a deleted domain themselves within 39 days from its page (CHF 58, which includes the next year); the expired email shows the deadline",
      "- Website hosting: build a one-page business website from a form (name, tagline, about, services, opening hours, contact, photo, four colour schemes), with a live preview; a coming-soon page can be turned into one",
      "- The payment-failed screen no longer crashes"
    ]
  },
  {
    version: "0.7.10-dev.1",
    date: "2026-10-04",
    changes: ["- Domains: customers restore a deleted domain themselves within 39 days from its page (the price includes the next year); the expired email shows the deadline"]
  },
  {
    version: "0.7.9",
    date: "2026-10-04",
    changes: ["- Domains: an expired domain deleted at the registry no longer keeps serving its former owner's site or forwarding, and its next owner starts with an empty DNS zone"]
  },
  {
    version: "0.7.9-dev.3",
    date: "2026-10-04",
    changes: ["- Business pages: conversion safety fixes (claim ownership, settled activation writes, guarded rollback)"]
  },
  {
    version: "0.7.9-dev.2",
    date: "2026-10-04",
    changes: ["- Business pages: review fixes (conversion is checked, serialized and recoverable; publish renders from the form only)"]
  },
  {
    version: "0.7.9-dev.1",
    date: "2026-10-04",
    changes: ["- Domains: an expired domain deleted at the registry no longer keeps serving its former owner's site or forwarding, and its next owner starts with an empty DNS zone"]
  },
  {
    version: "0.7.8",
    date: "2026-10-04",
    changes: [
      "- Website hosting: a site has three tabs (Overview, Edit, Domains); the Overview shows the next step and links to History and visitor numbers; one word per thing (Edit, History, Restore this version, Edit a copy of this version)",
      "- Website hosting: publishing is one step and always creates a new version; unsaved edits are saved first and the editor asks before edits are lost; Edit on a live site opens the live page's files",
      `- Put a free "Coming soon" page on a domain registered at YWT with one click, right after buying it or from the domain's page; edit its three fields any time`,
      "- Rename a site; share a draft with a link that expires after 1, 7 or 30 days and can be revoked with Stop sharing; download a version or the current draft as a zip",
      "- example.ch and www.example.ch count as one custom domain; only a connected domain can be made primary; clearer domain wording; folders starting with an underscore are supported",
      "- Removed the Git option, the detailed PageSpeed tab, the Overview shortcut cards and the sites search; dropped promises the product did not keep; templates no longer show forms that discard what visitors enter; payment success leads back to the website"
    ]
  },
  {
    version: "0.7.8-dev.10",
    date: "2026-10-04",
    changes: ["- Website hosting: the Overview updates right after saving a coming-soon page; Starter can add the www twin of its domain from the UI; version labels are unique"]
  },
  {
    version: "0.7.8-dev.9",
    date: "2026-10-04",
    changes: ["- Website hosting: Edit on a live site opens the live page's files instead of an empty start screen"]
  },
  {
    version: "0.7.8-dev.8",
    date: "2026-10-03",
    changes: ["- Router: draft tokens are redacted from logs even when the parameter name is percent-encoded"]
  },
  {
    version: "0.7.8-dev.7",
    date: "2026-10-03",
    changes: ["- Draft links: revocation takes effect immediately and cannot be undone by a concurrent action; tokens no longer appear in router logs; the site menu closes after a rename"]
  },
  {
    version: "0.7.8-dev.6",
    date: "2026-10-03",
    changes: ["- Website hosting: rename a site; share a draft with a link that expires after 1, 7 or 30 days and can be revoked with Stop sharing; download a version or the current draft as a zip"]
  },
  {
    version: "0.7.8-dev.5",
    date: "2026-10-03",
    changes: ["- Coming-soon pages: restore is limited to the page's own versions and re-checks the domain; DNS cleanup covers a write whose read-back failed"]
  },
  {
    version: "0.7.8-dev.4",
    date: "2026-10-03",
    changes: ["- Coming-soon pages: review fixes (publish from the rendered page only, eligibility re-checked on save, DNS cleaned up on a failed create)"]
  },
  {
    version: "0.7.8-dev.3",
    date: "2026-10-03",
    changes: [`- Put a free "Coming soon" page on a domain registered at YWT with one click, right after buying it or from the domain's page; edit its three fields any time`]
  },
  {
    version: "0.7.8-dev.2",
    date: "2026-10-03",
    changes: [
      "- Website hosting: a site has three tabs (Overview, Edit, Domains); the Overview shows the next step and links to History and visitor numbers",
      "- Website hosting: one word per thing: Edit, History, Restore this version, Edit a copy of this version; the free plan says what it is"
    ]
  },
  {
    version: "0.7.8-dev.1",
    date: "2026-10-03",
    changes: [
      "- Website hosting: publishing is one step and always creates a new version; unsaved edits are saved first and the editor asks before edits are lost",
      "- Website hosting: remove the Git option, the detailed PageSpeed tab, the Overview shortcut cards and the sites search; drop promises the product did not keep",
      "- Website hosting: example.ch and www.example.ch count as one custom domain; only a connected domain can be made primary; clearer domain wording",
      "- Website hosting: folders starting with an underscore are supported; templates no longer show forms that discard what visitors enter; payment success leads back to the website"
    ]
  },
  {
    version: "0.7.7",
    date: "2026-10-02",
    changes: [
      "- Add path redirects for hosted websites: send a path such as /feed.xml to another page or another domain, managed on the site's Domains page",
      "- Hosting plans: charge the renewal 3 days before the plan ends and retry daily; remind 7 days and 1 day before a plan that will not renew; take sites offline when a plan ends unpaid and bring them back automatically once it is paid",
      "- Never mark a paid domain registration or transfer as complete when the domain was not delivered; retry it, and re-check availability before charging",
      "- Charge a hosting renewal at most once per period, and refuse stale or duplicate plan orders at checkout",
      "- Checkout: block double clicks on Pay and show a clear message when a payment was declined",
      "- Switch web analytics to Microsoft Clarity with a cookie consent banner; remove Umami and the Google Ads tag",
      "- Security and privacy fixes across sign-in, admin access, carts, uploads, custom domain ownership, request logs, certificate and analytics limits, and the registry service"
    ]
  },
  {
    version: "0.7.7-dev.4",
    date: "2026-10-02",
    changes: ["- Shorter, friendlier wording for the analytics consent banner"]
  },
  {
    version: "0.7.7-dev.3",
    date: "2026-10-02",
    changes: ["- Show the analytics consent banner on dev, reporting to a separate Clarity project"]
  },
  {
    version: "0.7.7-dev.2",
    date: "2026-10-02",
    changes: [
      "- Switch web analytics to Microsoft Clarity with a cookie consent banner; remove Umami and the Google Ads tag",
      "- Limit how many new subdomain certificates a wildcard-forwarded domain can request per day",
      "- Limit how many analytics records a hosted site can create per hour"
    ]
  },
  {
    version: "0.7.7-dev.1",
    date: "2026-10-02",
    changes: [
      "- Add path redirects for hosted websites: send a path such as /feed.xml to another page or another domain, managed on the site's Domains page",
      "- Hosting plans: charge the renewal 3 days before the plan ends and retry daily; remind 7 days and 1 day before a plan that will not renew; take sites offline when a plan ends unpaid and bring them back automatically once it is paid",
      "- Never mark a paid domain registration or transfer as complete when the domain was not delivered; retry it, and re-check availability before charging",
      "- Charge a hosting renewal at most once per period, and refuse stale or duplicate plan orders at checkout",
      "- Checkout: block double clicks on Pay and show a clear message when a payment was declined",
      "- Security and privacy fixes across sign-in, admin access, carts, uploads, custom domain ownership, request logs and the registry service"
    ]
  },
  {
    version: "0.7.6",
    date: "2026-10-01",
    changes: [
      "- Let customers resume a cancelled website hosting subscription before its paid period ends; a confirmation email follows",
      "- Point the cancellation dialog and email to the new resume option instead of support",
      "- Keep backend integration tests on their own in-memory database and local test server"
    ]
  },
  {
    version: "0.7.6-dev.1",
    date: "2026-10-01",
    changes: [
      "- Let customers resume a cancelled website hosting subscription before its paid period ends; a confirmation email follows",
      "- Point the cancellation dialog and email to the new resume option instead of support",
      "- Keep backend integration tests on their own in-memory database and local test server"
    ]
  },
  {
    version: "0.7.5",
    date: "2026-10-01",
    changes: ['- Show only the domain table on the domains page by default; filters, CSV export and bulk actions open from a "Filters & bulk actions" toggle that is remembered per device']
  },
  {
    version: "0.7.4",
    date: "2026-09-18",
    changes: [
      "- Let customers delete their own account from the profile page; paid orders are retained for the statutory ten years",
      "- Let admins delete a customer's account from the admin users page",
      "- Block account deletion while domains are still registered or a paid order is being processed",
      "- Remove visitor analytics together with a deleted website",
      "- Build the frontend image on nginx 1.30 (Debian 13)"
    ]
  },
  {
    version: "0.7.4-dev.2",
    date: "2026-09-18",
    changes: [
      "- Keep the account deletion dialog inside the screen for accounts with many domains: the blocking domains scroll in a fixed-height list with a count",
      "- Shorten the account deletion refusal message to the first five domains",
      "- Build the frontend image on nginx 1.30 (Debian 13); the previous base could no longer be built"
    ]
  },
  {
    version: "0.7.4-dev.1",
    date: "2026-09-17",
    changes: [
      "- Let customers delete their own account from the profile page; paid orders are retained for the statutory ten years",
      "- Let admins delete a customer's account from the admin users page",
      "- Block account deletion while domains are still registered or a paid order is being processed",
      "- Remove visitor analytics together with a deleted website",
      "- Remove the unused invoices endpoint and collection code"
    ]
  },
  {
    version: "0.7.3",
    date: "2026-09-05",
    changes: [
      "- Add batch domain transfers, registrant maintenance and portfolio management",
      "- Guide customers to add a contact when no alternative domain holder exists",
      "- Align portfolio filter and search field heights"
    ]
  },
  {
    version: "0.7.3-dev.1",
    date: "2026-09-05",
    changes: [
      "- Add CSV and spreadsheet batch domain transfers",
      "- Add registrant contact maintenance and explicit domain holder changes",
      "- Add portfolio filters, sorting, bulk renewals, auto-renew management and CSV export",
      "- Handle empty cart responses consistently for first-time cart creation"
    ]
  },
  {
    version: "0.7.2",
    date: "2026-09-05",
    changes: [
      "- Reopen static hosting purchases, upgrades and renewals in production following development verification",
      "- Lower hosting catalogue prices: Starter CHF 3/month or CHF 30/year, Business CHF 9/month or CHF 90/year"
    ]
  },
  {
    version: "0.7.2-dev.1",
    date: "2026-09-05",
    changes: [
      "- Reopen static hosting purchases, upgrades and renewals in development and local environments; production sales remain closed",
      "- Development hosting price trial: Starter CHF 3/month or CHF 30/year, Business CHF 9/month or CHF 90/year"
    ]
  },
  {
    version: "0.7.1",
    date: "2026-08-30",
    changes: [
      "- Static hosting sunset (stop-sell): sales closed server-side (cart add, cart-to-order, upgrade and renewal orders) behind YWT_PUBLIC_CONFIG.staticHosting.salesClosed, plus discontinuation notice and removed purchase CTAs in the UI; existing subscriptions, cancellation, downgrades and webhook fulfillment unaffected",
      "- Expiry email fixes: 7-day reminder escalated and wording cleaned up across locales, auto-charge success email dates the new expiry from the charging year",
      "- Extracted shared SSRF destination checks into destination-security.util (used by URL forwarding), with dedicated unit tests"
    ]
  },
  {
    version: "0.7.0",
    date: "2026-07-07",
    changes: [
      "- Renewal notifications: pre-charge notice email (31-37 days before expiry), renewal confirmation email on registry sync, 14-day reminder only after a failed auto-charge",
      "- RenewalCycle state machine: one document per domain renewal period with a notification ledger as the email dedupe gate (legacy reminder flags dual-written)",
      "- Consolidated renewal billing: Amounts due page with pay-all into a single invoice, Renew Now creates the order directly instead of going through the cart",
      "- Stripe payment-method hygiene: duplicate cards deduped at attach time, default payment method only set when absent, open invoices re-pointed before detach",
      "- Fix BaseSchema _id default crashing on Mongoose upsert paths",
      "- Clock-walk integration test covering the full renewal timeline (4 scenarios, exact email counts)"
    ]
  },
  {
    version: "0.6.5",
    date: "2026-07-02",
    changes: [
      "- Layered test infrastructure (CI gate, integration harness, MSW frontend tests, security suites)",
      "- Fix duplicate payment-success emails on Stripe webhook redelivery",
      "- Fix cart id loss when anonymous cart merge fails",
      "- SSRF hardening in screenshot service (IPv6-mapped IPv4 forms)",
      "- Sentry cron monitors + route-404 capture",
      "- Fix backend container entrypoint: exclude vitest.int.config.ts from nest build so dist/main.js stays at the dist root"
    ]
  },
  {
    version: "0.6.4",
    date: "2026-06-26",
    changes: ["- Various updates"]
  },
  {
    version: "0.6.3",
    date: "2026-06-09",
    changes: ["- SEO improvements"]
  },
  {
    version: "0.6.2",
    date: "2026-06-03",
    changes: ["- Added docs feature"]
  },
  {
    version: "0.6.1",
    date: "2026-04-27",
    changes: ["- Added Sentry integration"]
  },
  {
    version: "0.6.0",
    date: "2026-04-09",
    changes: ["- Migrated from cloudflare to Caddy-VPS"]
  },
  {
    version: "0.5.0",
    date: "2026-04-05",
    changes: ["- Internal system migration"]
  },
  {
    version: "0.4.4",
    date: "2026-04-03",
    changes: ["- Additional security measures"]
  },
  {
    version: "0.4.3",
    date: "2026-04-03",
    changes: ["- Updated secrets handling"]
  },
  {
    version: "0.4.2",
    date: "2026-03-16",
    changes: ["- Added locale support"]
  },
  {
    version: "0.4.1",
    date: "2026-03-13",
    changes: ["- Added visitor analytics"]
  },
  {
    version: "0.4.0",
    date: "2026-03-08",
    changes: ["- Added subscription renewal and subscription plan change"]
  },
  {
    version: "0.3.6",
    date: "2026-02-01",
    changes: ["- Allow update current version of static site"]
  },
  {
    version: "0.3.5",
    date: "2026-01-10",
    changes: ["- Updated URL forwarding feature"]
  },
  {
    version: "0.3.4",
    date: "2026-01-08",
    changes: ["- Published static site hosting feature"]
  },
  {
    version: "0.3.3",
    date: "2026-01-06",
    changes: ["- Added feature to upgrade/downgrade subscription"]
  },
  {
    version: "0.3.2",
    date: "2026-01-04",
    changes: ["- Updated VAT and added FAQ"]
  },
  {
    version: "0.3.1",
    date: "2026-01-02",
    changes: ["- Optimized website workspace"]
  },
  {
    version: "0.3.0",
    date: "2026-01-01",
    changes: ["- Added static site hosting payment feature", "- update price schema", "- added subscription table"]
  },
  {
    version: "0.2.7",
    date: "2025-12-26",
    changes: ["- Optimize deployment process"]
  },
  {
    version: "0.2.6",
    date: "2025-12-25",
    changes: ["- Added acme client for SSL generation"]
  },
  {
    version: "0.2.5",
    date: "2025-12-21",
    changes: ["- Added static site hosting feature"]
  },
  {
    version: "0.2.4",
    date: "2025-12-15",
    changes: ["- Updated URL forwarding feature"]
  },
  {
    version: "0.2.3",
    date: "2025-12-14",
    changes: ["- Added URL forwarding feature"]
  },
  {
    version: "0.2.2",
    date: "2025-12-12",
    changes: ["- Added domain renewal check task"]
  },
  {
    version: "0.2.1",
    date: "2025-12-11",
    changes: ["- Added payment method management"]
  },
  {
    version: "0.2.0",
    date: "2025-12-07",
    changes: ["- Updated stripe to use invoice instead of payment intent"]
  },
  {
    version: "0.1.27",
    date: "2025-12-05",
    changes: ["- Fixed renewal issues"]
  },
  {
    version: "0.1.25",
    date: "2025-11-24",
    changes: ["- Updated SEO meta tags"]
  },
  {
    version: "0.1.24",
    date: "2025-11-23",
    changes: ["- Added whois lookup"]
  },
  {
    version: "0.1.23",
    date: "2025-11-22",
    changes: ["- Set scanning tasks for domain expiry"]
  },
  {
    version: "0.1.22",
    date: "2025-11-20",
    changes: ["- Added recovery email support", "- Updated tls client"]
  },
  {
    version: "0.1.21",
    date: "2025-11-18",
    changes: ["- Various improvements"]
  },
  {
    version: "0.1.20",
    date: "2025-11-17",
    changes: ["- Added EPP statistics panel"]
  },
  {
    version: "0.1.19",
    date: "2025-11-15",
    changes: ["- Added Transfer Out feature"]
  },
  {
    version: "0.1.18",
    date: "2025-11-15",
    changes: ["- Added DNSSEC management", "- Added Avartar feature"]
  },
  {
    version: "0.1.17",
    date: "2025-11-14",
    changes: ["- Added 2FA support"]
  },
  {
    version: "0.1.16",
    date: "2025-11-14",
    changes: ["- Added detailed logging for domain"]
  },
  {
    version: "0.1.15",
    date: "2025-11-13",
    changes: ["- Check domain expiry with only auto-renew domains"]
  },
  {
    version: "0.1.14",
    date: "2025-11-09",
    changes: ["- Updated SEO meta tags"]
  },
  {
    version: "0.1.13",
    date: "2025-10-30",
    changes: ["- Added EPP client resiliency knobs"]
  },
  {
    version: "0.1.12",
    date: "2025-10-25",
    changes: ["- Added cloud logging"]
  },
  {
    version: "0.1.11",
    date: "2025-10-23",
    changes: ["- Fixed transfer issue"]
  },
  {
    version: "0.1.10",
    date: "2025-10-12",
    changes: ["- Fixed transfer issue"]
  },
  {
    version: "0.1.9",
    date: "2025-10-10",
    changes: ["- DNS editing"]
  },
  {
    version: "0.1.8",
    date: "2025-09-24",
    changes: ["- DNSSEC management"]
  },
  {
    version: "0.1.7",
    date: "2025-09-24",
    changes: ["- Use PowerDNS for DNS records"]
  },
  {
    version: "0.1.6",
    date: "2025-09-06",
    changes: ["- Nameserver management"]
  },
  {
    version: "0.1.5",
    date: "2025-09-03",
    changes: ["- Config update"]
  },
  {
    version: "0.1.4",
    date: "2025-08-25",
    changes: ["- Config update"]
  },
  {
    version: "0.1.3",
    date: "2025-07-25",
    changes: ["- sprint 4"]
  },
  {
    version: "0.1.2",
    date: "2025-06-29",
    changes: ["- sprint 3"]
  },
  {
    version: "0.1.1",
    date: "2025-05-30",
    changes: ["- sprint 2"]
  },
  {
    version: "0.1.0",
    date: "2025-05-16",
    changes: ["- first version"]
  }
];

export {
  version_default
};
